import type { PaymentStatus } from '@/lib/api/sales-order-api'

/** How often (ms) to re-check an order while waiting for a bank transfer (no SSE). */
export const ORDER_POLL_MS = 4000

/**
 * Slower fallback interval used when SSE is connected. SSE delivers the
 * payment-confirmed event instantly; polling is kept only as a safety net for
 * SSE drops, so a longer interval avoids unnecessary requests while SSE is up.
 */
export const ORDER_POLL_SSE_FALLBACK_MS = 15_000

/**
 * TanStack Query refetchInterval for an order detail view.
 *
 * While `enabled` (e.g. a bank-transfer invoice popup is open and awaiting the
 * SePay webhook), poll until the order flips to `paid`, then stop. Returns
 * `false` to disable polling.
 *
 * When `sseConnected` is true, the poll interval is lengthened to
 * ORDER_POLL_SSE_FALLBACK_MS because the SSE stream will deliver the
 * payment-confirmed event instantly — polling only serves as a safety net.
 */
export function orderPollInterval(
    enabled: boolean,
    paymentStatus: PaymentStatus | undefined,
    sseConnected = false,
): number | false {
    if (!enabled) return false
    if (paymentStatus === 'paid') return false
    return sseConnected ? ORDER_POLL_SSE_FALLBACK_MS : ORDER_POLL_MS
}
